'use client';

import { BaseLineClose } from '@/app/components/icons/BaseLineClose';
import { cn, reportEvent } from '@/app/utils';
import { useLocale, useRouter } from '@/i18n/routing';

const CLAW_PATH = '/claw';

const BANNER_ASSETS = {
  bg: 'https://image01.cf.vidu.studio/vidu/media-asset/banner-bg-5c3500d5.webp',
  illustration: 'https://image01.cf.vidu.studio/vidu/media-asset/banner-illustration-2a0d493f.webp',
} as const;

const COPY = {
  zh: {
    lead: 'Agent 限时试用，免费制作 1 分钟视频。解锁你的 AI 助手',
    cta: '立即体验',
  },
  en: {
    lead: 'Agent Limited Trial - Get 1 minute of video for free. Unlock your AI assistant.',
    cta: 'Try Now',
  },
} as const;

export const ClawContentBanner = ({ onClose, className }: { onClose: () => void; className?: string }) => {
  const locale = useLocale();
  const router = useRouter();
  const copy = COPY[locale === 'zh' ? 'zh' : 'en'];

  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    reportEvent('element_click', { element_name: 'claw_content_top_banner_close' });
    onClose();
  };

  const goClaw = (elementName: string) => {
    reportEvent('element_click', { element_name: elementName });
    router.push(CLAW_PATH);
  };

  const handleBarClick = () => {
    goClaw('claw_content_top_banner_main');
  };

  const handleCtaClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    goClaw('claw_content_top_banner_cta');
  };

  return (
    <div
      className={cn(
        'relative isolate flex min-h-[41px] w-full cursor-pointer items-center justify-between overflow-hidden bg-[#2F3353] px-4',
        className,
      )}
      onClick={handleBarClick}
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0">
          <img src={BANNER_ASSETS.bg} alt="" className="h-full w-full object-cover" />
        </div>
      </div>

      <div className="relative z-10 flex h-full min-w-0 flex-1 items-center justify-center gap-3 overflow-hidden">
        <div className="flex h-full min-w-0 items-center gap-2 overflow-hidden whitespace-nowrap text-white text-xs">
          <img
            src={BANNER_ASSETS.illustration}
            alt=""
            width={82}
            height={36}
            className="mr-1 shrink-0 self-end sm:hidden"
          />
          <span className="shrink-0">{copy.lead}</span>
        </div>

        <div className="h-[14px] w-[1px] shrink-0 bg-system-white16 sm:hidden" />

        <button
          type="button"
          onClick={handleCtaClick}
          className="shrink-0 cursor-pointer rounded-[8px] border-0 bg-black px-3 py-1 font-semibold text-[10px] text-white leading-[1.4] transition-colors hover:bg-black/80 sm:hidden"
        >
          {copy.cta}
        </button>
      </div>

      <button
        type="button"
        onClick={handleClose}
        className="relative z-10 shrink-0 text-white transition-colors hover:text-white/80"
        aria-label="Close"
      >
        <BaseLineClose className="size-4" />
      </button>
    </div>
  );
};
